import { useState, useEffect } from "react";

import { RiCheckDoubleFill } from "react-icons/ri";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import {
  Col,
  Card,
  CardHeader,
  Button,
  Label,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import "./style.css";

const EvaluationADRAllocate = props => {
  const [loading, setLoading] = useState(true);
  const [isAllocating, setIsAllocating] = useState(false);
  const [activity, setActivity] = useState({});
  const [list, setList] = useState([]);
  const [rooms, setRooms] = useState({});
  const [selectedItems, setSelectedItems] = useState({});

  const [groups, setGroups] = useState([]);
  const [regions, setRegions] = useState([]);
  const [schools, setSchools] = useState([]);
  const [series, setSeries] = useState([]);

  const [groupId, setGroupId] = useState(0);
  const [regionId, setRegionId] = useState(0);
  const [schoolId, setSchoolId] = useState(0);
  const [serieId, setSerieId] = useState(0);

  const [removeModal, setRemoveModal] = useState(false);
  const [allocationToDelete, setAllocationToDelete] = useState(0);
  const [allocationItemToDelete, setAllocationItemToDelete] = useState({});

  useEffect(() => {
    (async () => {
      try {
        await axios
          .get(
            `${URL.api}activity/activity/singleView/${props.match.params.id}`,
            { headers: { Authorization: `Bearer ${props.user.token}` } }
          )
          .then(activityResponse => {
            setSerieId(activityResponse.data.data.serie_id);
            setActivity(activityResponse.data.data);
          });

        await axios
          .get(`${URL.api}access/group/list`, {
            headers: { Authorization: `Bearer ${props.user.token}` }
          })
          .then(groupsResponse => {
            setGroups(groupsResponse.data.data);
          });

        await axios
          .get(`${URL.api}classification/serie/list`, {
            headers: { Authorization: `Bearer ${props.user.token}` }
          })
          .then(seriesResponse => {
            setSeries(seriesResponse.data.data);
          });

        setGroupId(
          props.general.active_roles.group_id
            ? props.general.active_roles.group_id
            : 0
        );

        if (props.general.active_roles.role_id === 1) return;
        getRegions(props.general.active_roles.group_id);
      } catch (error) {
        handleError("Não foi possível obter as informações da alocação");
      }
    })();

    setLoading(false);
  }, []);

  useEffect(() => {
    setList([]);
    setRooms([]);
    setSelectedItems({});
  }, [groupId, regionId, schoolId]);

  const handleError = response => {
    if (response === "Unauthorized") {
      props.logout(props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  };

  const updateAllocation = () => {
    setLoading(true);
    setIsAllocating(true);

    const allocateObj = {
      activity_id: activity.id,
      serie_id: activity.serie_id,
      discipline_id: activity.discipline_id,
      start_allocation: null,
      end_allocation: null,
      groups: [groupId]
    };

    try {
      axios
        .post(`${URL.api}adr/allocate/insert`, allocateObj, {
          headers: { Authorization: `Bearer ${props.user.token}` }
        })
        .finally(resp => {
          toastr.success(
            "Atualização de Alocação feita com sucesso!",
            "A avaliação foi alocada nas turmas"
          );
          pullList(groupId, regionId, schoolId);
          setSelectedItems({});
          setLoading(false);
          setIsAllocating(false);
        });
    } catch (error) {
      handleError("Não foi possível atualizar a alocação da avaliação");
      setLoading(false);
      setIsAllocating(false);
    }
  };

  const allocateAction = async () => {
    setLoading(true);
    setIsAllocating(true);
    if (Object.keys(rooms).length > 0) {
      allocateToClassroom(rooms);
      return;
    }

    const allocateObj = {
      activity_id: activity.id,
      serie_id: activity.serie_id,
      discipline_id: activity.discipline_id,
      start_allocation: null,
      end_allocation: null
    };

    const itemsToSend = Object.keys(selectedItems).map(key => parseInt(key));

    let key = "groups";

    if (regionId) {
      const isEverySchool = schools.length === itemsToSend.length;

      key = isEverySchool ? "regions" : "schools";
      allocateObj[key] = isEverySchool ? [regionId] : itemsToSend;
    } else if (groupId) {
      const isEveryRegion = regions.length === itemsToSend.length;

      key = isEveryRegion ? "groups" : "regions";
      allocateObj[key] = isEveryRegion ? [groupId] : itemsToSend;
    }

    try {
      axios
        .post(`${URL.api}adr/allocate/insert`, allocateObj, {
          headers: { Authorization: `Bearer ${props.user.token}` }
        })
        .finally(resp => {
          toastr.success(
            "Alocada com sucesso!",
            "A avaliação foi alocada nas turmas"
          );
          pullList(groupId, regionId, schoolId);
          setSelectedItems({});
          setLoading(false);
          setIsAllocating(false);
        });
    } catch (error) {
      handleError("Não foi possível alocar a avaliação");
      setLoading(false);
      setIsAllocating(false);
    }
  };

  const allocateToClassroom = async () => {
    // const currYear = new Date().getFullYear();
    let allocateObj = {
      activity_id: activity.id,
      room_list: Object.values(selectedItems).map(room => ({
        allocation_id: 0,
        // start_allocation: `${currYear}-01-01T00:00:01`,
        // end_allocation: `${currYear}-01-02T00:00:01`,
        release: false,
        room_id: room.id,
        users: []
      }))
    };

    try {
      const allocationResponse = await axios.post(
        `${URL.api}activity/allocate/insert`,
        allocateObj,
        {
          headers: { Authorization: `Bearer ${props.user.token}` }
        }
      );

      const allocations = allocationResponse.data.data;

      const newList = [...list];
      allocations.forEach(allocation => {
        const changedItemIndex = newList.findIndex(
          item => item.id === allocation.room_id
        );
        newList[changedItemIndex].allocation_id = allocation.id;
      });
      setList(newList);
      toastr.success(
        "Alocada com sucesso!",
        "A avaliação foi alocada na turma"
      );
    } catch (error) {
      handleError("Não foi possível alocar a avaliação");
    }
  };

  const deleteAllocation = async () => {
    if (Object.keys(rooms).length > 0) {
      deleteRoomAllocation();
      return;
    }

    const deleteObj = {
      adr_allocation_id: allocationToDelete
    };

    if (regionId) {
      deleteObj.school_id = allocationItemToDelete.id;
    } else if (groupId) {
      deleteObj.region_id = allocationItemToDelete.id;
    } else {
      deleteObj.group_id = allocationItemToDelete.id;
    }

    try {
      await axios
        .post(`${URL.api}adr/allocate/delete`, deleteObj, {
          headers: { Authorization: `Bearer ${props.user.token}` }
        })
        .finally(() => {
          pullList(groupId, regionId, schoolId);
        });

      const newList = [...list];
      const changedItemIndex = newList.findIndex(
        item => item.allocation_id === allocationToDelete
      );
      newList[changedItemIndex].allocation_id = 0;
      setList(newList);

      toastr.success("Apagada com sucesso!", "A alocação foi apagada");
    } catch (error) {
      toastr.error("Falha", "Não foi possível apagar a alocação");
    }
    setRemoveModal(false);
    setAllocationToDelete(0);
  };

  const deleteRoomAllocation = async () => {
    const allocationId = allocationToDelete;
    try {
      await axios.post(
        `${URL.api}activity/allocate/delete`,
        { id: allocationId },
        {
          headers: { Authorization: `Bearer ${props.user.token}` }
        }
      );

      const newList = [...list];
      const changedItemIndex = newList.findIndex(
        item => item.allocation_id === allocationId
      );
      newList[changedItemIndex].allocation_id = 0;
      setList(newList);

      toastr.success("Apagada com sucesso!", "A alocação foi apagada");
    } catch (error) {
      toastr.error("Falha", "Não foi possível apagar a alocação");
    }

    setRemoveModal(false);
    setAllocationToDelete(0);
  };

  const toggleItemSelection = item => {
    const newSeletedItems = { ...selectedItems };

    if (newSeletedItems[item.id]) {
      delete newSeletedItems[item.id];
    } else {
      newSeletedItems[item.id] = item;
    }

    setSelectedItems(newSeletedItems);
  };

  const toggleAllRooms = () => {
    const newSelectedItems = {};
    list.forEach(item => {
      if (item.allocation_id) return;
      newSelectedItems[item.id] = item;
    });

    setSelectedItems(newSelectedItems);
  };

  const pullList = async (groupId = null, regionId = null, schoolId = null) => {
    setLoading(true);

    if (schoolId !== 0) {
      pullClassrooms(groupId, regionId, schoolId);
      return;
    }

    try {
      const allocationsResponse = await axios.get(
        `${URL.api}adr/allocate/accessListWithAllocation`,
        {
          params: {
            activity_id: props.match.params.id,
            group_id: groupId,
            region_id: regionId,
            school_id: schoolId
          },
          headers: { Authorization: `Bearer ${props.user.token}` }
        }
      );

      setList(allocationsResponse.data.data);
    } catch (error) {
      handleError("Não foi possível listar as informações");
    }

    setLoading(false);
  };

  const pullClassrooms = async (groupId, regionId, schoolId) => {
    const currYear = new Date().getFullYear();
    const objAllocate = {
      activity_id: activity.id,
      room_id: 0,
      user_id: 0
    };

    try {
      const allocateResponse = await axios.post(
        `${URL.api}activity/allocate/list`,
        objAllocate,
        {
          headers: { Authorization: `Bearer ${props.user.token}` }
        }
      );

      const allocations = allocateResponse.data.data;

      const roomsResponse = await axios.get(
        `${URL.api}community/room/listAllocationByFilter`,
        {
          params: {
            group_id: groupId,
            region_id: regionId,
            school_id: schoolId,
            series: JSON.stringify([serieId]),
            user_id: props.user.user.id,
            role_id: props.general.active_roles.role_id,
            class: true,
            start: `${currYear}-01-01`,
            end: `${currYear}-12-31`
          },
          headers: { Authorization: `Bearer ${props.user.token}` }
        }
      );

      const newList = roomsResponse.data.data.map(classroom => {
        const allocationRoom = allocations.find(
          allocation => allocation.room_id === classroom.id
        );
        return {
          id: classroom.id,
          name: classroom.name,
          allocation_id: allocationRoom?.id,
          start_allocation: allocationRoom?.start,
          end_allocation: allocationRoom?.end
        };
      });

      const roomsData = {};
      roomsResponse.data.data.forEach(room => {
        roomsData[room.id] = room;
      });

      setRooms(roomsData);
      setList(newList);
    } catch (error) {
      handleError("Não foi possível listar as informações");
    }

    setLoading(false);
  };

  const getRegions = async groupId => {
    try {
      const regionsResponse = await axios.get(
        `${URL.api}access/region/listRegionFilter/${groupId}`,
        {
          headers: { Authorization: `Bearer ${props.user.token}` }
        }
      );

      setRegions(regionsResponse.data.data);
    } catch {
      setRegions([]);
      handleError("Não foi possível obter as regiões");
    }
  };

  const getSchools = async (groupId, regionId) => {
    try {
      const schoolsResponse = await axios.get(
        `${URL.api}access/school/listSchoolFilter/${groupId}/${regionId}`,
        {
          headers: { Authorization: `Bearer ${props.user.token}` }
        }
      );

      setSchools(schoolsResponse.data.data);
    } catch {
      setSchools([]);
      handleError("Não foi possível obter as escolas");
    }
  };

  return (
    <>
      <Modal isOpen={removeModal}>
        <ModalHeader toggle={() => setRemoveModal(false)}>
          Deseja remover a alocação?
        </ModalHeader>
        <ModalBody>
          <p
            style={{
              padding: "20px 20px 0px 20px"
            }}
          >
            Ao remover a alocação, todos os agendamentos dessa avaliação serão
            removidos e os estudantes não poderão mais acessá-la.
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={() => deleteAllocation()}>
            Remover
          </Button>{" "}
          <Button color="secondary" onClick={() => setRemoveModal(false)}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
      <Breadcrumb
        current={props.currentRoute}
        items={[
          {
            path: "/evaluation/adr/allocate/:id",
            to: "/evaluation/adr/allocate"
          }
        ]}
      />
      <Row>
        {["G", "U", "R", "E"].includes(props.general.active_roles.type) && (
          <div className="d-flex w-100 justify-content-between align-items-end mb-4">
            <div className="w-100 mr-2">
              <Label className="d-block w-100 text-ellipsis">Séries</Label>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="fa fa-institution"></i>
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  type="select"
                  value={serieId}
                  placeholder="Série"
                  disabled
                >
                  <option value={0}>Todas</option>
                  {series?.map(item => (
                    <option value={item.id}>{item.name}</option>
                  ))}
                </Input>
              </InputGroup>
            </div>
            <div className="w-100 mr-2">
              <div className="w-100 text-ellipsis">
                <Label className="d-block w-100 text-ellipsis">Grupo</Label>
              </div>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="fa fa-wrench"></i>
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  type="select"
                  value={groupId}
                  placeholder="Grupo"
                  onChange={e => {
                    setGroupId(parseInt(e.target.value));
                    setRegionId(0);
                    setSchoolId(0);
                    getRegions(e.target.value);
                  }}
                  disabled={!!props.general.active_roles.group_id}
                >
                  <option value={0}>Todos</option>
                  {groups.map(item => (
                    <option value={item.id}>{item.name}</option>
                  ))}
                </Input>
              </InputGroup>
            </div>
            <div className="w-100 mr-2">
              <div className="w-100 text-ellipsis">
                <Label className="d-block w-100 text-ellipsis">Regional</Label>
              </div>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="fa fa-globe"></i>
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  type="select"
                  value={regionId}
                  placeholder="Regional"
                  disabled={!groupId || !!props.general.active_roles.region_id}
                  onChange={e => {
                    setSchoolId(0);
                    setRegionId(parseInt(e.target.value));
                    getSchools(groupId, e.target.value);
                  }}
                >
                  <option value={0}>Todas</option>
                  {regions?.map(item => (
                    <option value={item.id}>{item.name}</option>
                  ))}
                </Input>
              </InputGroup>
            </div>
            <div className="w-100 mr-2">
              <div className="w-100 text-ellipsis">
                <Label className="d-block w-100 text-ellipsis">Escola</Label>
              </div>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="fa fa-institution"></i>
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  type="select"
                  value={schoolId}
                  placeholder="Escola"
                  onChange={e => setSchoolId(parseInt(e.target.value))}
                  disabled={!regionId || !!props.general.active_roles.school_id}
                >
                  <option value={0}>Todas</option>
                  {schools?.map(item => (
                    <option value={item.id}>{item.name}</option>
                  ))}
                </Input>
              </InputGroup>
            </div>
            <Button
              color="primary"
              onClick={() => pullList(groupId, regionId, schoolId)}
            >
              Buscar
            </Button>
          </div>
        )}
        <hr className="hr" />
        <div className="w-100 d-flex align-items-center justify-content-between mb-4">
          <h3 className="mb-0 w-100">
            Aloque <strong>{activity.name}</strong> para{" "}
            {schoolId
              ? "as turmas:"
              : regionId
              ? "as escolas:"
              : groupId
              ? "as regionais:"
              : "os grupos:"}
          </h3>
          {!isAllocating && (
            <div className="d-flex align-items-center justify-content-end w-100">
              <Button
                style={{ marginRight: "10px" }}
                color="info"
                onClick={() => updateAllocation()}
              >
                Atualizar
              </Button>
              <Button color="secondary" onClick={() => toggleAllRooms()}>
                Selecionar todas
              </Button>

              {Object.keys(selectedItems).length > 0 && !loading && (
                <Button
                  color="primary"
                  onClick={() => allocateAction()}
                  className="ml-2"
                >
                  Alocar
                </Button>
              )}
            </div>
          )}
        </div>
        {loading ? (
          <div
            style={{ width: "100%" }}
            className="d-flex flex-column jusfity-content-center"
          >
            <Loading top="45" left="50" />
            {isAllocating && (
              <span className="text-center">
                Alocando. Por favor, aguarde...
              </span>
            )}
          </div>
        ) : (
          <Col md="12" className="p-0 m-0">
            {list?.length > 0 ? (
              <>
                {list?.map(item => (
                  <Card accentColor="primary" key={item.room_id}>
                    <CardHeader className="d-flex align-items-center justify-cotent-between rounded border-0">
                      <h5 className="m-0 p-0 flex-1 d-flex align-items-center">
                        {item.name}
                        {item.allocation_id && (
                          <RiCheckDoubleFill className="ml-2 text-success" />
                        )}
                      </h5>
                      {item.allocation_id ? (
                        <Button
                          color="danger"
                          onClick={() => {
                            setRemoveModal(true);
                            setAllocationToDelete(item.allocation_id);
                            setAllocationItemToDelete(item);
                          }}
                        >
                          Remover
                        </Button>
                      ) : (
                        <Button
                          className={`px-3 py-2 d-flex align-items-center h-100 user-card-allocate m-0 ${
                            item.id in selectedItems && "checked-primary"
                          }`}
                          onClick={() => toggleItemSelection(item)}
                        >
                          {item.id in selectedItems ? "Cancelar" : "Selecionar"}
                        </Button>
                      )}
                    </CardHeader>
                  </Card>
                ))}
              </>
            ) : (
              <div className="p-5 text-center text-muted w-100">
                {serieId || props.general.active_roles.school_id
                  ? "Nenhuma turma encontrada"
                  : "Selecione uma escola e uma série para realizar a alocação!"}
              </div>
            )}
          </Col>
        )}
      </Row>
      <ProtectedRoute routeId={props.currentRoute} />
    </>
  );
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EvaluationADRAllocate);
